
export class LoginFederado {
  
  public code: string;         
  public codeVerifier: string; 
  public nonce: string;        
  public state?: string;       
  public codCliente: string;  
  public docEmpresa: string;    
  public codTpoPortal: string;  

}
